let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7kuzy")).then(() => parcelRequire('fk3sU'));